import React from "react";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { db } from "firebase/fbConfig.js";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

import PickupsOrders from "./PickUpsOrders";

class Principles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTest: false,
      disableGroups: false
    };
  }

  loadGroups = (uid) => {
    console.log("loading groups");
    db.collection("TEST-users")
      .doc(uid)
      .collection('haney-groups')
      .get()
      .then(
        (snapshot) => {
          const newData = snapshot.docs.map(doc => doc.id);
          return newData;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((newData) => {
        this.setState({
          groupsData: newData,
          groupsDataLoaded: true,
        });
      });
  };

  handleSwitchChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const {
      classes,
      authUser,
    } = this.props;

    if (authUser) {
      if (!this.state.groupsDataLoaded) {
        this.loadGroups(authUser.uid);
      }
    }

    console.log(this.state);
    console.log(this.props);

    return this.state.groupsDataLoaded ? (
      <div>
        <GridContainer>
          <GridItem xs={7}>
            <b>Disable Groups:</b>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.disableGroups}
                  onChange={this.handleSwitchChange("disableGroups")}
                  value="disableGroups"
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.switchChecked,
                    icon: classes.switchIcon,
                    iconChecked: classes.switchIconChecked,
                    bar: classes.switchBar,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              style={{ marginLeft: "10px" }}
            />
          </GridItem>
          <GridItem xs={5}>
            <b>Test:</b>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.isTest}
                  onChange={this.handleSwitchChange("isTest")}
                  value="isTest"
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.switchChecked,
                    icon: classes.switchIcon,
                    iconChecked: classes.switchIconChecked,
                    bar: classes.switchBar,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              style={{ marginLeft: "10px" }}
            />
          </GridItem>
        </GridContainer>
        <PickupsOrders
          groups={this.state.groupsData}
          disableGroups={this.state.disableGroups}
          isTest={this.state.isTest}
        />
      </div>
    ) : (
      <p className={classes.body}>Loading...</p>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    authUser: state.auth.user,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Principles);



// WEBPACK FOOTER //
// ./src/views/Dispatch/PickUpsOrdersParent.jsx